module.exports = __webpack_public_path__ + "img/lights.8f28a356.webp";